import React from 'react';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Select from '../../Shared/UI/Select/components/Select';

import {
  monthNameFromNumber,
  meridiemIndicatorForHour,
  hourForTwelveHourClock,
  formattedMinute,
} from '../../Shared/timeHelpers';

import {
  useEventState,
  useEventActions,
} from './EventContext';

import styles from './EventDetails.module.scss';

const EventDetails = () => {
  const state = useEventState();
  const {
    updateStartDate,
    updateEndDate,
    updateStartTime,
    updateEndTime,
    updateTimezone,
    updateLocation,
    updateVenueType,
  } = useEventActions();

  const handleUpdateStartDay = (e) => {
    const [startYear, startMonth, startDay] = e.target.value.split("-");
    updateStartDate(startYear, startMonth, startDay);
  };

  const handleUpdateEndDay = (e) => {
    const [endYear, endMonth, endDay] = e.target.value.split("-");
    updateEndDate(endYear, endMonth, endDay);
  };

  const handleUpdateStartTime = (e) => {
    const [startHour, startMinute] = e.target.value.split(":");
    updateStartTime(startHour, startMinute);
  };

  const handleUpdateEndTime = (e) => {
    const [endHour, endMinute] = e.target.value.split(":");
    updateEndTime(endHour, endMinute);
  };

  const presentationMode = () => {
    if (state.loading || !state.event) {
      return null;
    }
    return (
      <div className={styles.event}>
        <div className={styles.textContainer}>
          <div id={styles.eventDetailsContainer}>
            <h3 id={styles.eventDetailsHeading}>Event Details:</h3>
            <p className={styles.eventDetails}>{`📅 Date: ${monthNameFromNumber(state.event.startMonth)} ${state.event.startDay}, ${state.event.startYear}`}</p>
            <p className={styles.eventDetails}>{`🕕 Time: ${hourForTwelveHourClock(state.event.startHour)}:${formattedMinute(state.event.startMinute)} ${meridiemIndicatorForHour(state.event.startHour)} - ${hourForTwelveHourClock(state.event.endHour)}:${formattedMinute(state.event.endMinute)} ${meridiemIndicatorForHour(state.event.endHour)} ${state.event.timezoneName}`}</p>
            <p className={styles.eventDetails}>{`📍 ${state.event.location}`}</p>
          </div>
        </div>
      </div>
    );
  };

  const editMode = () => {
    return (
      <Form>
        <Field label="Type Of Event">
          <Select
            value={state?.event?.venueType || 'online'}
            onChange={(e) => updateVenueType(e.target.value)}
          >
            <option value="online">Online</option>
            <option value="in_person">In Person</option>
            <option value="hybrid">Online and In Person</option>
          </Select>
        </Field>
        <h3 id={styles.eventDetailsHeading}>Event Details:</h3>
        <Field label="Start Date">
          <Input
            type="date"
            onChange={handleUpdateStartDay}
          />
        </Field>
        <Field label="End Date">
          <Input
            type="date"
            onChange={handleUpdateEndDay}
          />
        </Field>
        <Field label="Start Time">
          <Input
            type="time"
            onChange={handleUpdateStartTime}
          />
        </Field>
        <Field label="End Time">
          <Input
            type="time"
            onChange={handleUpdateEndTime}
          />
        </Field>
        <Field label="Timezone">
          <Select
            value={state?.event?.timezoneName || ''}
            onChange={(e) => updateTimezone(e.target.value)}
          >
            {(state.timezones || []).map((timezone) => (
              <option key={timezone.name} value={timezone.name}>
                {timezone.display_name}
              </option>
            ))}
          </Select>
        </Field>
        <Field label="Location">
          <Input
            type="text"
            value={state?.event?.location || ''}
            onChange={(e) => updateLocation(e.target.value)}
          />
        </Field>
      </Form>
    );
  };

  return (
    <div className={styles.event}>
      {state.inEditMode ?
        (
          editMode()
        ) : (
          presentationMode()
        )
      }
    </div>
  );
};

export default EventDetails;
